import React from 'react'
import {Link} from 'react-router-dom'

type CollectionLayoutProps = {
  children: React.ReactNode
}

export default function CollectionLayout({children}: CollectionLayoutProps) {
  return (
    <>
      <div className='row mb-5 mt-n5 pt-n5 align-items-center'>
        <div className='col-6'>
          <h2 className='py-3 mb-0'>Collections</h2>
        </div>
        <div className='col-6 align-self-center text-end my-3'>
          <Link to='/collections/create'>
            <button type='button' className='btn btn-primary '>
              Create
            </button>
          </Link>
        </div>
      </div>
      <div className='card py-5 px-8'>
        {children}
      </div>
    </>
  )
}

